import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useModal } from '@gluedigital/modal'

declare const window: any
declare const __CLIENT__: boolean

__CLIENT__ && require('src/capacitor')

const CapacitorHack = () => {
  const navigate = useNavigate()

  const modal = useModal()

  useEffect(() => {
    window.myNavigate = navigate
    window.myModal = modal

    if (window.myHistoryQueue) {
      navigate(window.myHistoryQueue)
    }
  }, [navigate, location, modal])

  return null
}

export default CapacitorHack
